import React, { useCallback } from 'react';
import { FlatList, StyleSheet, } from 'react-native';
import { rem } from 'design-system/values';
import { extractKeyFromKey } from 'utils/flatListHelpers';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { NativeViewGestureHandler } from 'react-native-gesture-handler';
import { UnavailableOnWebModal } from 'utils/packages/UnavailableOnWebModal';
import SectionHeader from '../../../invest/components/SectionHeader';
import LearnVideoCard from './LearnVideoCard';
import { isWeb } from '../../../../constants';
const LearnSection = ({ contentContainerStyle, learnVideos, }) => {
    const { navigateDeprecated } = useMainStackNavigation();
    // Show only 3 videos on web
    const displayedVideos = isWeb ? learnVideos.slice(0, 3) : learnVideos;
    const handlePress = useCallback((index, learnVideos) => () => {
        if (isWeb) {
            UnavailableOnWebModal.show('emma://learn', 'Play video');
        }
        else {
            navigateDeprecated('InvestLearn', {
                videoIndex: index,
                learnVideos,
            });
        }
    }, []);
    const renderItem = useCallback(({ item, index }) => (<LearnVideoCard title={item.name} key={index} thumbnail={item.thumbnail} onPress={handlePress(index, displayedVideos)}/>), [handlePress, displayedVideos]);
    const onSeeMorePress = useCallback(() => {
        if (isWeb) {
            UnavailableOnWebModal.show('emma://learn', 'Play video');
        }
        else {
            navigateDeprecated('LearnVideos', { learnVideos });
        }
    }, [learnVideos]);
    if (!learnVideos?.length) {
        return null;
    }
    return (<>
      <SectionHeader title="Videos" {...(learnVideos?.length > 2 && {
        onSeeMorePress: () => onSeeMorePress(),
    })} style={contentContainerStyle}/>
      <NativeViewGestureHandler disallowInterruption>
        <FlatList scrollEnabled={!isWeb && learnVideos?.length > 2} horizontal data={displayedVideos} renderItem={renderItem} initialNumToRender={4} style={styles.overflowVisible} keyboardShouldPersistTaps="handled" showsHorizontalScrollIndicator={false} keyExtractor={extractKeyFromKey('name')} contentContainerStyle={[
            styles.containerStyles,
            contentContainerStyle,
        ]}/>
      </NativeViewGestureHandler>
    </>);
};
export default React.memo(LearnSection);
const styles = StyleSheet.create({
    containerStyles: {
        paddingHorizontal: rem(12),
    },
    overflowVisible: {
        overflow: 'visible',
    },
});
